import request from '../requestPB'
import { SERVER_DOMAIN, PROTO_MODULE } from '../constant'

// 查询颜色列表
export const fetchColorList = () => {
  return request({
    url: `${SERVER_DOMAIN}/product/colorInfoList`,
    data: {},
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductColorListRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductColorListResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.PRODUCT,
    // TOKEN_REQUIRED: true
  })
}

// 查询成色列表
export const fetchNewDegreeList = (params) => {
  return request({
    url: `${SERVER_DOMAIN}/product/newDegreeInfoList`,
    data: params,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductNewsRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductNewsResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.PRODUCT,
    // TOKEN_REQUIRED: true
  })
}

// 查询尺码列表
export const fetchSizeList = (params) => {
  return request({
    url: `${SERVER_DOMAIN}/product/sizeInfoList`,
    data: params,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductSizeListRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductSizeListResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.PRODUCT,
    // TOKEN_REQUIRED: true
  })
}

// AI 识包结果   /aiservice/v2/newClassify
export const fetchSkcInfo = (params) => {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       errorCode: 0,
  //       errorMsg: 'Success',
  //       // hasMatch: true, // 是否匹配成功
  //       // logId: 3834, // 用来反馈记录
  //       holmesResult: [
  //         {
  //           mainPic: [
  //             'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75',
  //             'https://oss.turingsenseai.com/baogo1602582974768490894.png?x-oss-process=image/sharpen,100/resize,p_75',
  //             'https://oss.turingsenseai.com/baogo1602583011770822099.png?x-oss-process=image/sharpen,100/resize,p_75',
  //             'https://oss.turingsenseai.com/baogo1602583069825310953.png?x-oss-process=image/sharpen,100/resize,p_75'
  //           ],
  //           kindId: 83,
  //           brandId: 93,
  //           seriesId: 103,
  //           description: '这个背包，老好了，给铁锅炖大鹅都不换的那种，灵感来源于东北二人转艺术表演形式，大家好，“大红背心往里掖，谁给鼓掌谁是爹',
  //           brandEnName: 'LOUIS VUITTON', // 品牌名称
  //           seriesName: '黑色边角系列', // 系列名称
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包', // 商品名称
  //           onSaleCount: 10, // 在售数量
  //           skc: 'skc123456', // skc
  //           colorName: '红色', // 颜色
  //           productCode: '', // 货号
  //           measurement: '中号', // 尺寸
  //           releasePrice: '4500', // 发售价格（官方价）
  //           releaseDate: '', // 发售日期
  //           origin: '法国巴黎', // 产地
  //           forPeople: '1', // 适用人群，0：女， 1： 男
  //           materialStr: '皮革', // 材质
  //           overflowPrice: '142', // 溢价
  //           similarCount: 25, // 相似款式总数
  //           pidSimilarItem: [ // 相似款式列表
  //             {
  //               mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //               saleCount: 10, // 在售总量
  //               skc: 'skc123', // skc
  //               newsDetails: [ // 成色和价格列表
  //                 {
  //                   newOld: '全新底价',
  //                   price: '80000',
  //                 },
  //                 {
  //                   newOld: '95新底价',
  //                   price: '65000',
  //                 },
  //               ],
  //               brandEnName: 'LOUIS VUITTON',
  //               seriesName: '黑色边角系列',
  //               productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //               sizeName: '大号',
  //               kindId: 83,
  //               brandId: 93,
  //             },
  //             {
  //               mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75'
  //             },
  //           ],
  //           worldPriceItem: [ // 全球价格
  //             {
  //               country: '中国',
  //               websitePrice: '5000', // 官网价格
  //               rmbPrice: '25000', // 人民币价格
  //             },
  //             {
  //               country: '美国',
  //               websitePrice: '1890', // 官网价格
  //               rmbPrice: '34000', // 人民币价格
  //             },
  //             {
  //               country: '欧洲',
  //               websitePrice: '2500', // 官网价格
  //               rmbPrice: '25340', // 人民币价格
  //             }
  //           ],
  //           productNewsItem: [ // 全网比价
  //             {
  //               newsName: '99新',
  //               netPrice: 25500,
  //               newsNetWorkNum: 2200,
  //               sevenDayCompare: -2,
  //               graphPrice: [
  //                 {
  //                   time: '2020-10-12',
  //                   source: '1', // 包小鉴
  //                   price: 45000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-13',
  //                   source: '1',
  //                   price: 50000,
  //                 },
  //                 {
  //                   time: '2020-10-14',
  //                   source: '1',
  //                   price: 60000,
  //                 },
  //                 {
  //                   time: '2020-10-15',
  //                   source: '1', // 包小鉴
  //                   price: 45000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-16',
  //                   source: '1',
  //                   price: 50000,
  //                 },
  //                 {
  //                   time: '2020-10-17',
  //                   source: '1',
  //                   price: 60000,
  //                 },
  //                 {
  //                   time: '2020-10-18',
  //                   source: '1',
  //                   price: 90000,
  //                 },
  //                 {
  //                   time: '2020-10-12',
  //                   source: '2', // 包小鉴
  //                   price: 90000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-13',
  //                   source: '2',
  //                   price: 70000,
  //                 },
  //                 {
  //                   time: '2020-10-14',
  //                   source: '2',
  //                   price: 60000,
  //                 },
  //                 {
  //                   time: '2020-10-15',
  //                   source: '2', // 包小鉴
  //                   price: 55000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-16',
  //                   source: '2',
  //                   price: 30000,
  //                 },
  //                 {
  //                   time: '2020-10-17',
  //                   source: '2',
  //                   price: 40000,
  //                 },
  //                 {
  //                   time: '2020-10-18',
  //                   source: '2',
  //                   price: 80000,
  //                 },
  //                 {
  //                   time: '2020-10-12',
  //                   source: '3', // 包小鉴
  //                   price: 33000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-13',
  //                   source: '3',
  //                   price: 57000,
  //                 },
  //                 {
  //                   time: '2020-10-14',
  //                   source: '3',
  //                   price: 48000,
  //                 },
  //                 {
  //                   time: '2020-10-15',
  //                   source: '3', // 包小鉴
  //                   price: 73000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-16',
  //                   source: '3',
  //                   price: 63000,
  //                 },
  //                 {
  //                   time: '2020-10-17',
  //                   source: '3',
  //                   price: 82000,
  //                 },
  //                 {
  //                   time: '2020-10-18',
  //                   source: '3',
  //                   price: 80000,
  //                 },
  //               ],
  //               networkPrice: [
  //                 {
  //                   salePrice: '26500',
  //                   source: '1', // 平台
  //                   productNum: 45, // 商品销量
  //                 },
  //                 {
  //                   salePrice: '26500',
  //                   source: '2', // 平台
  //                   productNum: 45, // 商品销量
  //                 },
  //                 {
  //                   salePrice: '26500',
  //                   source: '3', // 平台
  //                   productNum: 45, // 商品销量
  //                 },
  //               ]
  //             },
  //             {
  //               newsName: '95新',
  //               netPrice: 25500,
  //               newsNetWorkNum: 2200,
  //               sevenDayCompare: -2,
  //               graphPrice: [
  //                 {
  //                   time: '2020-10-12',
  //                   source: '1', // 包小鉴
  //                   price: 15000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-13',
  //                   source: '1',
  //                   price: 50000,
  //                 },
  //                 {
  //                   time: '2020-10-14',
  //                   source: '1',
  //                   price: 60000,
  //                 },
  //                 {
  //                   time: '2020-10-15',
  //                   source: '1', // 包小鉴
  //                   price: 15000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-16',
  //                   source: '1',
  //                   price: 30000,
  //                 },
  //                 {
  //                   time: '2020-10-17',
  //                   source: '1',
  //                   price: 60000,
  //                 },
  //                 {
  //                   time: '2020-10-18',
  //                   source: '1',
  //                   price: 40000,
  //                 },
  //                 {
  //                   time: '2020-10-12',
  //                   source: '2', // 包小鉴
  //                   price: 90000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-13',
  //                   source: '2',
  //                   price: 70000,
  //                 },
  //                 {
  //                   time: '2020-10-14',
  //                   source: '2',
  //                   price: 60000,
  //                 },
  //                 {
  //                   time: '2020-10-15',
  //                   source: '2', // 包小鉴
  //                   price: 55000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-16',
  //                   source: '2',
  //                   price: 30000,
  //                 },
  //                 {
  //                   time: '2020-10-17',
  //                   source: '2',
  //                   price: 40000,
  //                 },
  //                 {
  //                   time: '2020-10-18',
  //                   source: '2',
  //                   price: 80000,
  //                 },
  //                 {
  //                   time: '2020-10-12',
  //                   source: '3', // 包小鉴
  //                   price: 33000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-13',
  //                   source: '3',
  //                   price: 57000,
  //                 },
  //                 {
  //                   time: '2020-10-14',
  //                   source: '3',
  //                   price: 40000,
  //                 },
  //                 {
  //                   time: '2020-10-15',
  //                   source: '3', // 包小鉴
  //                   price: 23000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-16',
  //                   source: '3',
  //                   price: 53000,
  //                 },
  //                 {
  //                   time: '2020-10-17',
  //                   source: '3',
  //                   price: 72000,
  //                 },
  //                 {
  //                   time: '2020-10-18',
  //                   source: '3',
  //                   price: 80000,
  //                 },
  //               ],
  //               networkPrice: [
  //                 {
  //                   salePrice: '26500',
  //                   source: '1', // 平台
  //                   productNum: 35, // 商品销量
  //                 },
  //                 {
  //                   salePrice: '26500',
  //                   source: '2', // 平台
  //                   productNum: 5, // 商品销量
  //                 },
  //                 {
  //                   salePrice: '26500',
  //                   source: '3', // 平台
  //                   productNum: 45, // 商品销量
  //                 },
  //               ]
  //             },
  //             {
  //               newsName: '92新',
  //               netPrice: 25500,
  //               newsNetWorkNum: 2200,
  //               sevenDayCompare: -2,
  //               graphPrice: [
  //                 {
  //                   time: '2020-10-12',
  //                   source: '1', // 包小鉴
  //                   price: 45000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-13',
  //                   source: '1',
  //                   price: 50000,
  //                 },
  //                 {
  //                   time: '2020-10-14',
  //                   source: '1',
  //                   price: 60000,
  //                 },
  //                 {
  //                   time: '2020-10-15',
  //                   source: '1', // 包小鉴
  //                   price: 45000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-16',
  //                   source: '1',
  //                   price: 50000,
  //                 },
  //                 {
  //                   time: '2020-10-17',
  //                   source: '1',
  //                   price: 60000,
  //                 },
  //                 {
  //                   time: '2020-10-18',
  //                   source: '1',
  //                   price: 90000,
  //                 },
  //                 {
  //                   time: '2020-10-12',
  //                   source: '2', // 包小鉴
  //                   price: 90000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-13',
  //                   source: '2',
  //                   price: 70000,
  //                 },
  //                 {
  //                   time: '2020-10-14',
  //                   source: '2',
  //                   price: 60000,
  //                 },
  //                 {
  //                   time: '2020-10-15',
  //                   source: '2', // 包小鉴
  //                   price: 55000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-16',
  //                   source: '2',
  //                   price: 30000,
  //                 },
  //                 {
  //                   time: '2020-10-17',
  //                   source: '2',
  //                   price: 40000,
  //                 },
  //                 {
  //                   time: '2020-10-18',
  //                   source: '2',
  //                   price: 80000,
  //                 },
  //                 {
  //                   time: '2020-10-12',
  //                   source: '3', // 包小鉴
  //                   price: 33000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-13',
  //                   source: '3',
  //                   price: 57000,
  //                 },
  //                 {
  //                   time: '2020-10-14',
  //                   source: '3',
  //                   price: 48000,
  //                 },
  //                 {
  //                   time: '2020-10-15',
  //                   source: '3', // 包小鉴
  //                   price: 73000, // 价格
  //                 },
  //                 {
  //                   time: '2020-10-16',
  //                   source: '3',
  //                   price: 63000,
  //                 },
  //                 {
  //                   time: '2020-10-17',
  //                   source: '3',
  //                   price: 82000,
  //                 },
  //                 {
  //                   time: '2020-10-18',
  //                   source: '3',
  //                   price: 80000,
  //                 },
  //               ],
  //               networkPrice: [
  //                 {
  //                   salePrice: '26500',
  //                   source: '1', // 平台
  //                   productNum: 15, // 商品销量
  //                 },
  //                 {
  //                   salePrice: '26500',
  //                   source: '2', // 平台
  //                   productNum: 25, // 商品销量
  //                 },
  //                 {
  //                   salePrice: '26500',
  //                   source: '3', // 平台
  //                   productNum: 45, // 商品销量
  //                 },
  //               ]
  //             }
  //           ],
  //           // newsList: [
  //           //   '全新',
  //           //   '98新',
  //           //   '95新'
  //           // ],
  //           skcList: [ // skc列表
  //             'skc123',
  //             'skc234',
  //             'skc345'
  //           ],

  //           newsDetails: [ // 成色列表
  //             {
  //               newOld: '98新',
  //               price: '20000',
  //             }
  //           ],
  //         }
  //       ]
  //     })
  //   }, 1000)
  // })
  
  return request({
    url: `${SERVER_DOMAIN}/product/marketEncyclopedia`,
    data: params,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSMarketEncyclopediaRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSMarketEncyclopediaResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.PRODUCT,
    TOKEN_REQUIRED: true
  })
}

// AI识包相似skc POST@token_required /aiservice/SimilarProduct
export const fetchSimilarList = (params) => {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       errorCode: 0,
  //       errorMsg: 'Success',
  //       count: 22,
  //       skcSimilarItem: [
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602582932468721276.png?x-oss-process=image/sharpen,100/resize,p_75', // 相似主图
  //           saleCount: 10, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //         {
  //           mainPic: 'https://oss.turingsenseai.com/baogo1602573363744050479.png?x-oss-process=image/sharpen,100/resize,p_75',
  //           saleCount: 15, // 在售总量
  //           skc: 'skc123', // skc
  //           newsDetails: [ // 成色和价格列表
  //             {
  //               newOld: '全新底价',
  //               price: '80000',
  //             },
  //             {
  //               newOld: '95新底价',
  //               price: '65000',
  //             },
  //           ],
  //           brandEnName: 'LOUIS VUITTON',
  //           seriesName: '黑色边角系列',
  //           productName: 'LV 路易威登 经典老花中号neverful单肩包',
  //           sizeName: '大号',
  //           kindId: 83,
  //           brandId: 93,
  //         },
  //       ]
  //     })
  //   }, 500)
  // })
  return request({
    url: `${SERVER_DOMAIN}/aiservice/v2/similar`,
    data: params,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductSimilarRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductSimilarResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.AI_SERVICE,
    TOKEN_REQUIRED: true
  })
}

// 商城搜索接口
export const fetchMallProduct = (params) => {
  console.log(params);
  return request({
    url: `${SERVER_DOMAIN}/search/getMallSearchList`,
    data: params,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSMallSearchRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSMallSearchResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.SEARCH,
    TOKEN_REQUIRED: true
  })
}

// 查询交易记录列表
export const fetchTradeList = (params) => {
  return request({
    url: `${SERVER_DOMAIN}/admin/orderList`,
    data: params,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSTradeOrderListRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSTradeOrderListResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.SEARCH,
    TOKEN_REQUIRED: true
  })
}

export const fetchResult = (params) => {
  console.log(params);
  return request({
    url: `${SERVER_DOMAIN}/aiservice/v2/newClassify`,
    data: params,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductAiHolmesRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductAiHolmesResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.SEARCH,
    TOKEN_REQUIRED: true
  })
}

export const feedBackProduct = (params) => {
  return request({
    url: `${SERVER_DOMAIN}/product/productFeedback`,
    data: params,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.ProductFeedbackQuestionRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.ProductFeedbackQuestionResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.PRODUCT,
    TOKEN_REQUIRED: true
  })
}

// AI 识包结果   /aiservice/v2/newClassify
export const fetchSkcInfoByImg = (params) => {
  return request({
    url: `${SERVER_DOMAIN}/aiservice/v2/newClassify`,
    method: 'POST',
    data: params
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductAiHolmesRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductAiHolmesResponse',
    TOKEN_REQUIRED: true,
    // ERROR_ACTION: 'toast'
  })
}

export const fetchSkcInfoNew = (params) => {
  return request({
    url: `${SERVER_DOMAIN}/product/marketNewEncyclopedia`,
    method: 'POST',
    data: params
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSMarketNewEncyclopediaRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSMarketNewEncyclopediaResponse',
    TOKEN_REQUIRED: true,
    // ERROR_ACTION: 'toast'
  })
}
